import { render, staticRenderFns } from "./UploadCSV.vue?vue&type=template&id=1a7b1ddf&"
import script from "./UploadCSV.vue?vue&type=script&lang=js&"
export * from "./UploadCSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports